export default "__VITE_ASSET__8xxeMUFP__"